import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import "./../../../css/app.css";
import { useLocation, useHistory } from "react-router-dom";
import { useAlert } from "react-alert";
import { dencode as base64_dencode } from "base-64";
const appparameters = require("../../../core/common.jsx");

const Activateaccount = (props) => {
  const [state, setState] = useStateIfMounted({
    loading: true,
    result: "",
  });
  const location = useLocation();
  const alert = useAlert();
  const history = useHistory();
  useEffect(() => {
    // Read from the query string, not route params. The activation token is a
    // signed JWT that can run well over 255 bytes - as a URL PATH SEGMENT that
    // exceeds the filesystem's per-component name limit, and the static file
    // server (checking for a matching file before falling back to the SPA)
    // throws ENAMETOOLONG instead of ever reaching this component. Query
    // string values aren't checked against the filesystem, so this has no
    // such limit.
    const searchParams = new URLSearchParams(location.search);
    const username = searchParams.get("username");
    const token = searchParams.get("token");
    if (username == undefined || token == undefined) {
      history.push("/");
      alert.show("Unauthorized page request", {
        type: "error",
        position: "middle",
      });
    } else {
      fetch(appparameters.backend_app_url + "/frontend/activateaccount", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, token }),
      })
        .then((res) => res.json()) //.json()
        .then((response) => {
          //console.log("request result from login ");
          //console.log(response);
          setState({ loading: false, result: response });
        });
    }
  }, []);

  //when componenet unmount
  useEffect(() => () => "", []);

  if (state.loading) {
    return (
      <div className="container">
        <center>
          <img
            src={require("./../../../images/simpleloading.gif")}
            className="simpleloadingview"
          />
          <p>
            <strong> Activating account ... </strong>
            <br />
          </p>
        </center>
      </div>
    );
  } else if (state.result) {
    return (
      <div className="container">
        <center>
          <img
            src={require("./../../../images/success.png")}
            style={{ width: "20vw", height: "25vh" }}
          />
          <p>
            <strong>Account activated successfully </strong>
            <br />
          </p>
        </center>
      </div>
    );
  } else {
    return (
      <div className="container">
        <center>
          <img
            src={require("./../../../images/failed.png")}
            style={{ width: "20vw", height: "25vh" }}
          />
          <p>
            <strong>Failed to activate account</strong>
            <br />
          </p>
        </center>
      </div>
    );
  }
};
export default Activateaccount;
